import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

const authFileHeaders = (token) => {
  const headers = authHeaders(token);
  if (headers["Content-Type"]) {
    delete headers["Content-Type"];
  }
  return headers;
};

export async function getPortalSettings(salonId, token) {
  const res = await axios.get(
    `${API}/client-portal/admin/salons/${salonId}/settings`,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function updatePortalSettings(salonId, payload, token) {
  const res = await axios.put(
    `${API}/client-portal/admin/salons/${salonId}/settings`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function listPortalRegistrations(salonId, status = "pending", token) {
  const res = await axios.get(
    `${API}/client-portal/admin/salons/${salonId}/registrations`,
    {
      params: { status },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function approvePortalRegistration(registrationId, payload, token) {
  const res = await axios.post(
    `${API}/client-portal/admin/registrations/${registrationId}/approve`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function rejectPortalRegistration(registrationId, payload, token) {
  const res = await axios.post(
    `${API}/client-portal/admin/registrations/${registrationId}/reject`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getPortalHelperMapping(salonId, token) {
  const res = await axios.get(`${API}/manage/client-portal/helper-mapping`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function autoMapPortalHelperMapping(salonId, token) {
  const res = await axios.post(
    `${API}/manage/client-portal/helper-mapping/auto-map`,
    { salon_id: salonId },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function savePortalHelperMapping(payload, token) {
  const res = await axios.post(
    `${API}/manage/client-portal/helper-mapping/save`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function uploadPortalLogo(salonId, file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(
    `${API}/manage/client-portal/upload-logo`,
    formData,
    {
      params: { salon_id: salonId },
      headers: authFileHeaders(token),
    }
  );
  return res.data;
}

export async function deletePortalLogo(salonId, token) {
  const res = await axios.delete(`${API}/manage/client-portal/upload-logo`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function uploadPortalBackground(salonId, file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(
    `${API}/manage/client-portal/upload-background`,
    formData,
    {
      params: { salon_id: salonId },
      headers: authFileHeaders(token),
    }
  );
  return res.data;
}

export async function deletePortalBackground(salonId, token) {
  const res = await axios.delete(
    `${API}/manage/client-portal/upload-background`,
    {
      params: { salon_id: salonId },
      headers: authHeaders(token),
    }
  );
  return res.data;
}
